import $ from 'jquery';
import Mustache from 'mustache';
import Bloodhound from 'vendor/typeahead';
import Keyboard from '../../../styleguide/src/assets/modules/keyboard';
import get from 'lodash/get';
import '../modules/abtest/smart-filters';

function initSearch() {
  const $desktopSearch         = $( ".site-search" );
  const $tabletSearchTray      = $( ".site-search-tray" );
  const $searchWrap            = $( ".site-search__wrap" );
  const $searchOverlay         = $( ".site-search-tray__overlay" );
  const $searchIconButton      = $( ".tablet-site-search__icon" );
  const $searchForm            = $( ".js-form-search" );
  const $searchInput           = $( ".js-site-search__textbox" );
  const $clearSearchBtn        = $( ".js-form-search__x" );
  const $closeButton           = $( ".site-search__close" );
  const $noResultSearchCTA     = $( "#nRS" );
  const $noResultSearchWrapper = $( "#nRSM" );
  const $noResultSearchInput   = $( "#nRSC" );
  const formSearchFull         = 'form-search--full';
  let searchAppended         = false;
  let searchActive           = false;

  $clearSearchBtn.on('click', resetSearch);
  $searchInput.on('input', initControls);

  function showFormControls() {
    $searchForm.addClass( formSearchFull );
  }

  function hideFormControls() {
    $searchForm.removeClass( formSearchFull );
  }

  function resetSearch() {
    $searchInput.focus();
    hideFormControls();
  }

  function initControls(e) {
    if ($(e.target).val().length > 0) {
      showFormControls();
    } else {
      hideFormControls();
    }
  }

  function noResultsSearchTabletHide(){
    $noResultSearchWrapper.hide();
    $noResultSearchInput.show();
  }

  function hideSearch() {
    $tabletSearchTray.slideUp("600", "easeInOutExpo");
    $searchOverlay.fadeOut("800", function(){
      searchActive = false;
    });
  }

  function trayToggle() {
    $searchInput.val('');

    if (searchActive) {
      $tabletSearchTray.slideUp("600", "easeInOutExpo");
      $searchOverlay.fadeOut("800", function(){
        searchActive = false;
      });

      hideFormControls();
    } else {
      $searchOverlay.fadeIn("800");
      $tabletSearchTray.slideDown("600", "easeInOutExpo");
      $searchInput.focus();
      searchActive = true;
    }
  }

  function appendDesktopSearch() {
    if (searchAppended) {
      noResultsSearchTabletHide();
      $searchWrap.appendTo( $desktopSearch );
      $searchIconButton.off( "click", trayToggle );
      $noResultSearchCTA.off( "click", trayToggle )
      $searchOverlay.off( "click", hideSearch );
      hideSearch();
      hideFormControls();
      searchAppended = false;
    }
  }

  $(function() {
    appendDesktopSearch();
  });
}

/*
* search.js
*/

function initSearchSuggestions(){
  /*
  Suggestive Search
  =================
  */

  const searchDep = $(".js-site-search__textbox").data("dep");
  const rcProps = get(window, 'rcProps.search', {}); //see constants in /r/scripts.jsp

  // Products
  const productsBH = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace("productName"),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: '/r/ajax/VisualSearch.jsp?q=%QUERY&d=' + searchDep,
      wildcard: '%QUERY'
    }
  });

  // Text Suggestions
  const textSuggestionsBH = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace("searchTerm"),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url : '/r/ajax/TextSuggestions.jsp?q=%QUERY&d=' + searchDep,
      wildcard: '%QUERY'
    }
  });

  const displaySuggestionsForNoInput = rcProps.displaySuggestionsForNoInput;

  // Divert Tab into the suggestions panel only while it is actually open and
  // visible. When it is closed, do nothing so native Tab moves focus to the
  // next control (the submit icon). Hijacking Tab unconditionally and then
  // focusing a hidden results container is a no-op, which trapped keyboard
  // focus in the search field.
  $('.js-site-search__textbox').on("keydown", function(e) {
    const keyCode = e.keyCode || e.which;
    if (keyCode !== 9 || e.shiftKey) return;

    const $siteSearchResults = $('.site-search__results');
    if ($siteSearchResults.is(':visible')) {
      e.preventDefault();
      $siteSearchResults.attr('tabindex', '0').focus();
    }
  });

  $('.js-site-search__textbox#js-no-results-target').on("keydown",function(e){
    const keyCode = e.keyCode || e.which;
    if (keyCode == 9 && !e.shiftKey) {
      e.preventDefault();
      $('.search-results__cta').focus();
    }
  });

  //AB Test 854 - Smart Filters Logic
  $('.js-site-search__textbox:not(.ab854__search__textbox)').typeahead({
    hint: false,
    highlight: true,
    autoselect: false,
    minLength: 0,
    classNames: {
      menu: 'site-search__results',
      highlight: 'site-search__highlight'
    }
  },

  {
    name : 'textSuggestions',
    display: function(obj){
      return obj.suggestion;
    },
    source: textSuggestionsBH,
    templates: {
      header: function() {
        return rcProps.textSuggestionHeader;
      },
      suggestion : function(data) {
        const gender = (data.gender || '').toLowerCase();
        
        return Mustache.render(rcProps.textSuggestionTemplate, {
          href: data.suggestionUrl,
          suggestion: data.suggestion,
          isBrand: data.termType === "Brand" || data.termType === 'Brand Category',
          isWomens: gender === 'womens',
          isMens: gender === 'mens',
          isKids: gender === 'kids'
        });
      }
    },
    limit: rcProps.textSuggestionLimit
  },

  {
    name: 'recent',
    display: function(obj) {
      return obj.searchText;
    },
    source: function(query, callback) {
      callback(JSON.parse(rcProps.recentSearchJson));
    },
    templates: {
      header: function() {
          return rcProps.recentSearchHeader;
      },
      suggestion: function(data) {
          return Mustache.render(rcProps.recentSearchTemplate, data);
      }
    },
    limit: rcProps.recentSearchLimit
  },

  {
    name: 'products',
    display: 'productName',
    source: productsBH,
    templates: {
      header: function(data) {
        if (data && data.query && data.query.length >= rcProps.minLengthBeforeSearching ) {
          return rcProps.relatedProductsHeader;
        } else {
          return rcProps.recentlyViewedHeader;
        }
      },
      suggestion: function(data){
        /* backticks for multiline literal, see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals */
        return Mustache.render(rcProps.productSuggestionTemplate, data);
      }
    },
    limit: rcProps.productSuggestionLimit // TODO GRAP-10426: set limit to 12
  }).on('click', function(){
    if (typeof logEngagement === 'function'){
      logEngagement(window.location.href, 'Search Box', 'Click');
    }
  });

  // Stacked Search Suggestion Layout
  $(".tt-dropdown-menu").addClass("site-search__predictions").css({
    "left" : "",
    "z-index" : "",
    "right" : ""
  });

  // Update: Ensure results container is focusable
  $('.js-site-search__textbox').on('typeahead:render', function(e) {
    if($('.site-search__suggestions .tt-suggestion ').length) {
      wrapSuggestionsHandler()
      $('#js-aria-search-result').text( $('.site-search__results .tt-suggestion ').length + rcProps.ariaText);
    } else {
      $('#js-aria-search-result').text(rcProps.noResultsText);
    }
    wrapHorizontalResults();
  });

  $('.site-search__results').on('focus', function(e){
    // add tt-open class from typeahead.js and add tabindex for tabbing
    $(this).show().addClass('tt-open').attr('tabindex', '0');
  });

  // Close Results and focus on Submit Icon when tabbing past last item
  $('.site-search__results').on('focusout', function(evt) {
      const $el = $(this);
      const $focusable = Keyboard.findFocusable($el);
      const $firstFocusable = $focusable.eq(0);
      const $lastFocusable = $focusable.eq(-1);
      const isFirstItem = evt.target === $firstFocusable[0];
      const isLastItem = evt.target === $lastFocusable[0];
      const isTab = Keyboard.parseKey(evt) === 'TAB';
      if (isLastItem) {
        // Keyboard.releaseFocus($el);
        $el.hide().removeClass('tt-open trapped').removeAttr('tabindex');
        $('.site-search__submit').focus();
      }
  });

  $('.js-site-search__textbox').on('typeahead:cursorchange', function(ev, suggestion) {
    let index;
    if(suggestion && 'index' in suggestion) index = suggestion.index;
    else index = -1;

    let text = "";
    if(!suggestion){
      $('#js-aria-search-result').text(text);
    }else{
      //Search results are only two type, if not Product, we put them all to SUGGESTION type.
      if(suggestion.termType == 'Product'){
        if(index == 0) text ="Related Products" + " " + suggestion.brand + " " + suggestion.productName + " " + suggestion.price;
        else text = suggestion.brand + " " + suggestion.productName + " " + suggestion.price;
      }else {
        if(index == 0) text ="Suggestions" + " " + suggestion.suggestion;
      }
      $('#js-aria-search-result').text(text);
    }
  });

  $(".twitter-typeahead").addClass("site-search__typeahead").css({display:"block"});
  $(".tt-dataset-textSuggestions").addClass("site-search__suggestions");
  $(".tt-dataset-recent").addClass("js-recent-searches");
  $(".tt-dataset-products").addClass("predict-related");
}
function wrapHorizontalResults() {
  const $suggestionCarousel = $('.js-search-suggestion-horizontal')
  if($suggestionCarousel && $suggestionCarousel.parent().hasClass('product'))
  return;
  $suggestionCarousel.wrap('<div class="product grid__col"></div>')
  const $suggestionItemWrap = $suggestionCarousel.parent();
  $suggestionItemWrap.wrapAll('<div class="grid n-block-grid--3 u-margin-t--lg u-padding-b--sm site-search__placeholder"></div>');
}

function wrapSuggestions($el) {
  if($el && $el.parent().hasClass('ui-list__item'))
  return;
  $el.wrap('<li class="ui-list__item js-search-suggestion-item-wrap"></li>');
  const $suggestionItemWrap = $el.parent();
  $suggestionItemWrap.wrapAll('<ul class="ui-list"></ul>');
}


function wrapSuggestionsHandler() {
  const $suggestionItem = $('.js-search-suggestion-item');
  const $simpleSuggestionItem = $('.js-search-simple-suggestion-item');
  wrapSuggestions($suggestionItem);
  wrapSuggestions($simpleSuggestionItem);
}

export default () => {
  if(!$('.js-site-search__textbox').length) {
    return;
  }

  function handleScreenWidth() {
    if (window.innerWidth <= 1001) {
      if ($('.site-header--pill').length > 0) {
        $('.site-search__submit').addClass('u-margin-t--xs')
        $('.site-search__textbox').addClass('u-padding-tb--md');
      } else {
        $('.site-search__textbox').removeClass('u-padding-tb--md');
        $('.site-search__submit').removeClass('u-margin-t--xs')
      }
    } else {
    }
  }

  handleScreenWidth();

  window.addEventListener('resize', () => {
    handleScreenWidth();
  });

  initSearch();
  initSearchSuggestions();
};



// WEBPACK FOOTER //
// ./src/scripts/modules/search.js